import angular from 'angular';

import AxiosService from './axios.service';
import AwsService from './aws.service';
import ManifestService from './manifest.service';
import MapService from './map.service';
import ShadowService from './shadow.service';
import EventsService from './events.service';
import MomentService from './moment.service';

const module = angular
    .module('app.services', [])
    .service('AxiosService', AxiosService)
    .service('AwsService', AwsService)
    .service('ManifestService', ManifestService)
    .service('MapService', MapService)
    .service('ShadowService', ShadowService)
    .service('EventsService', EventsService)
    .service('MomentService', MomentService)
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/services/index.js